import _ from "lodash";
import { SURVEY_FLOW } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        surveyFlow: _.cloneDeep(constants.SURVEY_FLOW),
        common: {
            haveDraft: localStorage.getItem('haveDraft') == 'true' ? true : false
        }
    }
}

const surveyFlowReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SURVEY_FLOW.SET_SURVEY_FLOW:
            return {
                ...state,
                ui: {
                    ...state.ui,
                    surveyFlow: action.surveyFlow
                }
            }
        case SURVEY_FLOW.SET_SURVEY_HAVE_DRAFT:
            localStorage.setItem('haveDraft', action.haveDraft)
            return {
                ...state,
                ui: {
                    ...state.ui,
                    common: {
                        ...state.ui.common,
                        haveDraft: action.haveDraft
                    }
                }
            }
        default:
            return state
    }
}

export default surveyFlowReducer